import { verificationsApi } from '../../../data/verificationsApi';
import type { DashboardCounts } from './dashboardViews';

/**
 * Dashboard feature endpoints — the center-scoped category counts that drive the landing tiles.
 * Injected into the single verifications base api; feature-owned (not shared).
 */
export const dashboardEndpoints = verificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardCounts: builder.query<DashboardCounts, { center?: string }>({
      query: ({ center }) => ({
        url: '/verification/dashboard/counts',
        method: 'GET',
        params: { center },
      }),
      providesTags: (result, error, { center }) => [
        { type: 'DashboardCounts', id: center ?? 'ALL' },
        'DashboardCounts',
      ],
      // Five minutes of retention so a return visit paints from cache while the hook's background
      // refetch is still in flight. It removes the wait, not the request.
      keepUnusedDataFor: 300,
    }),
  }),
  overrideExisting: false,
});

export const { useGetDashboardCountsQuery } = dashboardEndpoints;
